<template>
  <svg
    :style="style"
    :width="svgWidth"
    :height="svgHeight"
    :viewBox="`0 0 ${svgWidth} ${svgHeight}`"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path :d="outerPath" :fill="borderColor" />
    <path :d="innerPath" :fill="fillColor" />
  </svg>
</template>

<script setup>
// Modules
import { computed } from "vue"
// Consts
import ARROW_SIDES from "../../consts/arrow";

const props = defineProps({
  direction: {
    type: Number,
    default: 1,
  },
  width: {
    type: Number,
    default: 18,
  },
  height: {
    type: Number,
    default: 7,
  },
  borderSize: {
    type: Number,
    default: -1,
  },
  borderColor: {
    type: String,
    default: "#222",
  },
  fillColor: {
    type: String,
    default: "#fff",
  },
  offset: {
    type: Number,
    default: 24,
  },
});

const isHorizontal = computed(() => {
  return props.direction === ARROW_SIDES.TOP||props.direction === ARROW_SIDES.BOTTOM
});

const svgWidth = computed(() => {
  return isHorizontal.value ? props.width : props.height;
});

const svgHeight = computed(() => {
  return isHorizontal.value ? props.height : props.width;
});

const style = computed(() => {
  switch (props.direction) {
    case ARROW_SIDES.TOP:
      return {
        position: "absolute",
        left: `${props.offset}px`,
        top: `-${props.height}px`,
        width: `${props.width}px`,
        height: `${props.height}px`,
        display: "block",
        overflow: "visible",
        lineHeight: 0,
      };

    case ARROW_SIDES.BOTTOM:
      return {
        position: "absolute",
        left: `${props.offset}px`,
        bottom: `-${props.height}px`,
        width: `${props.width}px`,
        height: `${props.height}px`,
        display: "block",
        overflow: "visible",
        lineHeight: 0,
      };

    case ARROW_SIDES.LEFT:
      return {
        position: "absolute",
        left: `-${props.height}px`,
        top: `${props.offset}px`,
        width: `${props.height}px`,
        height: `${props.width}px`,
        display: "block",
        overflow: "visible",
        lineHeight: 0,
      };

    case ARROW_SIDES.RIGHT:
      return {
        position: "absolute",
        right: `-${props.height}px`,
        top: `${props.offset}px`,
        width: `${props.height}px`,
        height: `${props.width}px`,
        display: "block",
        overflow: "visible",
        lineHeight: 0,
      };

    default:
      return {}
  }
});

const outerPath = computed(() => {
  const w = props.width;
  const h = props.height;

  switch (props.direction) {
    case ARROW_SIDES.TOP:
      return `M0 ${h} L${w / 2} 0 L${w} ${h} Z`;
    case ARROW_SIDES.BOTTOM:
      return `M0 0 L${w / 2} ${h} L${w} 0 Z`;
    case ARROW_SIDES.LEFT:
      return `M${h} 0 L0 ${w / 2} L${h} ${w} Z`;
    case ARROW_SIDES.RIGHT:
      return `M0 0 L${h} ${w / 2} L0 ${w} Z`;
    default:
      return "";
  }
});

const innerPath = computed(() => {
  const w = props.width;
  const h = props.height;
  const b = props.borderSize;

  switch (props.direction) {
    case ARROW_SIDES.TOP:
      return `M${b} ${h} L${w / 2} ${b} L${w - b} ${h} Z`;
    case ARROW_SIDES.BOTTOM:
      return `M${b} 0 L${w / 2} ${h - b} L${w - b} 0 Z`;
    case ARROW_SIDES.LEFT:
      return `M${h} ${b} L${b} ${w / 2} L${h} ${w - b} Z`;
    case ARROW_SIDES.RIGHT:
      return `M0 ${b} L${h - b} ${w / 2} L0 ${w - b} Z`;
    default:
      return "";
  }
});
</script>
